import { render, staticRenderFns } from "./DeviceGas.vue?vue&type=template&id=470d640c&scoped=true&"
import script from "./DeviceGas.vue?vue&type=script&lang=js&"
export * from "./DeviceGas.vue?vue&type=script&lang=js&"
import style0 from "./DeviceGas.vue?vue&type=style&index=0&id=470d640c&lang=scss&scoped=true&"
import style1 from "./DeviceGas.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d640c",
  null
  
)

export default component.exports